import { render, staticRenderFns } from "./ConfigurationItemHeader.vue?vue&type=template&id=3ab4313e&scoped=true"
import script from "./ConfigurationItemHeader.vue?vue&type=script&lang=js"
export * from "./ConfigurationItemHeader.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationItemHeader.vue?vue&type=style&index=0&id=3ab4313e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab4313e",
  null
  
)

export default component.exports